<template>
    <div>
        <!-- 过滤条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="商品状态"
                clearable
                v-model="filter.enabled"
                @on-change="search"
            >
                <Option
                    v-for="item in enums.isEnable"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
        </div>
        <table-tool-bar style="margin-top: 16px">
            <template slot="left">
                <table-searcher
                    v-model="filter.title"
                    placeholder="请输入品类名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('add')"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
                >新增品类</Button
            >
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:attachments="{ row }">
                <base-img
                    v-for="(item, index) in getImgPath(row)"
                    :key="index"
                    height="30"
                    width="30"
                    type="path"
                    :src="item"
                    style="margin-left: 5px"
                ></base-img>
            </template>
            <template v-slot:enabled="{ row }">
                <i-switch
                    v-model="row.enabled"
                    :disabled="!$can('update')"
                    size="large"
                    :true-value="1"
                    :false-value="0"
                    @on-change="toEnabled(row)"
                >
                    <span slot="open">启用</span>
                    <span slot="close">禁用</span>
                </i-switch>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    >详情</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showPCatalogForm"
            :title="curId ? '品类详情' : '新增品类'"
            :width="800"
            :height="450"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <m-catalog-form v-if="modal.showPCatalogForm" :id="curId" />
        </smart-modal>
    </div>
</template>
<script>
import { mapCell } from "_c/grid/renderCell";
import MCatalogForm from "./m-catalog-form";
import BaseImg from "_c/base-img";
import { catalogList, catalogEnable } from "@/api/merch";
import yzyList from "_v/common/yzy-list";
import Enum from "@/config/global-enum";

const PAGE_SIZE = 20;

export default {
    mixins: [yzyList],
    name: "m-catalog-list",

    components: {
        MCatalogForm,
        BaseImg,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: this.$cache.merchCatalog || {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                title: "",
                enabled: "",
            },
            enums: {
                isEnable: this.$enum.get("isEnable").toList(),
            },
            curId: "",
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showPCatalogForm: false,
            },
        };
    },

    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "title",
                    title: "品类名称",
                    align: "left",
                    minWidth: 160,
                },
                {
                    key: "sortNum",
                    title: "排序",
                    align: "left",
                    minWidth: 80,
                },
                {
                    key: "attachments",
                    title: "图标",
                    align: "left",
                    minWidth: 80,
                    slot: "attachments",
                },
                {
                    key: "remark",
                    title: "备注",
                    align: "left",
                    minWidth: 200,
                },
                {
                    key: "enabled",
                    title: "状态",
                    align: "center",
                    width: 100,
                    slot: "enabled",
                    fixed: "right",
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 100,
                    slot: "action",
                    fixed: "right",
                },
            ];
        },
    },

    watch: {},

    created() {
        this.fetch();
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80;
        });
    },

    methods: {
        fetch() {
            this.loading = true;

            Promise.all([catalogList(this.filter)])
                .then((args) => {
                    var [page] = args;

                    this.setPageData(page.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },

        setPageData(data) {
            this.page.list = data.page.list.sort(
                (a, b) => a.sortNum - b.sortNum
            );
            this.page.total = parseInt(data.page.totalCount);
        },

        onClickAdd(e) {
            this.modal.showPCatalogForm = true;
            this.curId = "";
        },

        rowClickInfo(row) {
            this.curId = row.id;
            this.modal.showPCatalogForm = true;
        },

        toEnabled(row) {
            catalogEnable(row.id)
                .then(() => {
                    this.$Message.success(this.$t("tips.update.success"));
                })
                .finally(() => this.fetch());
        },

        getImgPath(row) {
            let arr = JSON.parse(row.attachments || "[]");
            return arr.map((el) => el.path);
        },
    },
};
</script>
<style lang="less" scoped></style>
